/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} TrackingInputs */

const en_tracking = /** @type {(inputs: TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tracking:`)
};

const es_tracking = /** @type {(inputs: TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seguimiento:`)
};

const fr_tracking = /** @type {(inputs: TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suivi :`)
};

const de_tracking = /** @type {(inputs: TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sendungsverfolgung:`)
};

const ja_tracking = /** @type {(inputs: TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`追跡番号:`)
};

const zh_tracking = /** @type {(inputs: TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`物流追踪：`)
};

const ar_tracking = /** @type {(inputs: TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التتبع:`)
};

const id_tracking = /** @type {(inputs: TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelacakan:`)
};

const it_tracking = /** @type {(inputs: TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tracciamento:`)
};

const ru_tracking = /** @type {(inputs: TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отслеживание:`)
};

const pt_tracking = /** @type {(inputs: TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rastreamento:`)
};

const ko_tracking = /** @type {(inputs: TrackingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`배송 추적:`)
};

/**
* | output |
* | --- |
* | "Tracking:" |
*
* @param {TrackingInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const tracking = /** @type {((inputs?: TrackingInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<TrackingInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tracking(inputs)
	if (locale === "es") return es_tracking(inputs)
	if (locale === "fr") return fr_tracking(inputs)
	if (locale === "de") return de_tracking(inputs)
	if (locale === "ja") return ja_tracking(inputs)
	if (locale === "zh") return zh_tracking(inputs)
	if (locale === "ar") return ar_tracking(inputs)
	if (locale === "id") return id_tracking(inputs)
	if (locale === "it") return it_tracking(inputs)
	if (locale === "ru") return ru_tracking(inputs)
	if (locale === "pt") return pt_tracking(inputs)
	return ko_tracking(inputs)
});